<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 473.895 319.292">
    <title>Indirizzo e-mail presente</title>
    <path
      d="M28.8 0h389.26c15.73 0 28.52 12.88 28.5 28.53l-.1 95.75c-7.58-2.84-15.46-5.04-23.59-6.55l.07-77.07-125.82 98.89 9.17 8.99c-3.04 2.56-5.94 5.24-8.75 8.04l-.09.1c-3.27 3.27-6.37 6.72-9.32 10.29l-10.89-10.69-42.14 35.87c-4.49 3.77-11.46 4.22-16.5.11l-44.24-36.09L39.45 282.69h219.27c1.54 8.04 3.779 15.929 6.69 23.58l-236.92.02C12.74 306.29 0 293.42 0 277.76L.24 28.52C.27 12.84 13.05 0 28.8 0zm-5.19 261.9l130.45-122.08L23.82 41.69l-.21 220.21zM42.65 23.6l183.96 141.87L400.69 23.6H42.65zm399.06 141.917l-89.407 89.42-40.833-40.833-32.169 32.169 40.842 40.828-.038.038 32.169 32.153 121.605-121.606-32.169-32.169z"
      fill="#5bb55e"
    />
  </svg>
</template>

<script>
export default {};
</script>